<template>
  <div class="background">
    <div class="logo">
      <a href="#">
        <img src="" class="img-logo"/>
      </a>
    </div>
    <div class="login-div">
      <div class="login">
        <h1>3500用户登陆</h1>
        <div style="display: flex;justify-content: center;margin-bottom: 20px">
          <img src=".././assets/study.png" width="30px" height="30px">
        </div>
        <div class="input-text">
          <input type="text" id="inputEmail" name="email" placeholder="Account" v-model="username"/>
        </div>

        <div class="input-text">
          <input type="password" id="inputPassword" name="password" placeholder="Password" v-model="password"/>
        </div>

        <div>
          <b-button class="signin-button" variant="danger" @click="login()">登陆</b-button>
        </div>
        <div>
          <b-button class="signup-button" variant="warning" @click="goback_homepage()">返回</b-button>
        </div>
        <div>
          <b-button class="clear-button" variant="success" @click="clearInput()">清除</b-button>
        </div>
        <div class="warning-input" id="warningPassword">
          账号或密码错误
        </div>
      </div>
    </div>
  </div>

</template>
<script>
import filterWords from "@/components/filterWords";
import axios from 'axios'
import {Dialog, Toast} from 'vant';
import $ from 'jquery'

export default {
  name: 'login_pc',
  components: {},
  data(){
    return {
      username:'',
      password:''
    }
  },
  methods: {
    _isMobile() {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      return flag;
    },
    gotoFilter(){
      if(this._isMobile()) {
        this.$router.push({name: 'filterWords', params: {}});
      }else{
        this.$router.push({ name: 'homepage_pc'});
      }
    },
    goback_homepage(){
      this.$router.push({ name: 'homepage'});
    },
    // 清除输入框
    clearInput(){
      this.username = ''
      this.password = ''
    },
    // 用户登陆
    // 登录按钮
    login(){
      let res = new Promise((resolve, reject) => {
        resolve(this.queryUsername())
      });
      res = res.then( res =>{
        if(res != 'nook'){
          this.$store.commit('changeLogin', res['token']);
          // this.getLocalStorage();
          this.$router.push({ name: 'homepage_pc', });
          this.$message.success('3500用户登陆');
          return 'ok'
        }else{
          this.$message.error('账号密码错误');
        }
      })
      res.then( res => {
        let tokenStr = window.localStorage.getItem('Authorization3500');
        let userString = decodeURIComponent(escape(window.atob(tokenStr.split('.')[1])))
        let tokenData = JSON.parse(userString);
        let username = tokenData['data']['username'];
        this.$store.state.userShow = username.substr(0, 3);
      })

    },
    // 后端请求数据
    async queryUsername() {
      this.$store.state.loadingWords = true;
      let params = new URLSearchParams();
      params.append('method', 'post');
      params.append('username', this.commonApi.trimStr(this.username.toLowerCase()));
      params.append('password', this.password);
      return await axios.post('wordsuser/', params).then( (ret) => {
        this.$store.state.loadingWords = false;
        return ret.data;
      })
    },

  },
  watch: {
  },
  activated() {
  },
  mounted() {
    // 更改css
    $(".van-nav-bar__right").css({'padding': '0px'});
  },

}
</script>

<style scoped>

.input-text {
  margin-bottom: 20px;
}

.input-text input {
  width: 100%;
  height: 45px;
  background-color: white;
  color: black;
  border-radius: 5px;
  border: none;
  outline: transparent;
  text-indent: 18px;
}

.input-text input::-webkit-input-placeholder {
  font-size: 1rem;
  color: #999;
}

.input-text input::-moz-placeholder {
  font-size: 1rem;
  color: #999;
  text-indent: 40px;
}

.background {
  margin: 0;
  padding: 0;
  /*background: url(".././assets/shoolkids.jpg") no-repeat center center;*/
  /*background: url(".././assets/table2.jpg") no-repeat center center;*/
  background: #220B15;
  /*background: linear-gradient(to top right, #65349D, #3D39AC, #6ECFCF);*/
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  height: 100%;
  display: flex;
  /*flex-direction: column;*/
  /*align-self: center;*/
  justify-content: center;
  align-items: center
}

.login {
  /*margin: auto;*/

  width: 500px;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 5px;
  padding: 50px 70px 100px 70px;
}

.login h1 {
  color: white;
  padding-bottom: 20px;
}

.beian {
  margin-top: 10%;
  font-size: 8px;
  background: none;
  color: white;
  display: flex;
  flex-direction: column;
  align-items: center
}
.beian1 {
  background: none;
  color: white;
}
.beian2 {
  display: flex;
  text-decoration:none;
  line-height:20px;
  background: none;
  color: white;
}

.img-beian{
  margin: 2px 1px 0 2px;
}

.signin-button {
  margin-top: 10px;
  height: 60px;
  width: 100%;
  padding: 13px;
  border-radius: 5px;
  background-color: red;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 1.05rem;
  cursor: pointer;
}

.signup-button {
  margin-top: 10px;
  height: 60px;
  width: 100%;
  padding: 13px;
  border-radius: 5px;
  background-color: #d39e00;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 1.05rem;
  cursor: pointer;
}

.clear-button {
  margin-top: 10px;
  height: 60px;
  width: 100%;
  padding: 13px;
  border-radius: 5px;
  background-color: #507E2A;
  color: white;
  border: none;
  font-weight: bold;
  font-size: 1.05rem;
  cursor: pointer;
}

.warning-input {
  visibility: hidden;
  /* display: none; */
  color: rgb(232, 3, 3);
  font-weight: 700;
  font-size: 0.8rem;
  margin-top: 10px;
}

.protection a {
  text-decoration: none;
}

.protection a:hover {
  text-decoration: underline;
}

@media screen and (max-width: 740px) {
  .login h1 {
    color: white;
    padding-bottom: 10px;
    font-size: 20px;
  }
  .img-logo {
    margin-left: 22px;
  }
  .login {
    padding: 40px 30px 153px 30px;
    width: 65%;
    /*align-self: center;*/
    margin-left: 20%;
  }
  .login-div {
    width: 90%;
    margin: 10px auto;
  }
  /*.beian {*/
  /*  width: 50%;*/
  /*  margin-top: 10%;*/
  /*  margin-left: 21%;*/
  /*}*/
}
/*手机*/
@media screen and (max-width: 500px) {
  .login h1 {
    color: white;
    align-self: center;
  }
  .login {
    width: 90%;
    align-self: center;
    padding: 40px 30px 83px 30px;
    margin: 20% 0 40% 5%;
  }
  .beian {
    width: 50%;
    margin-left: 20%;
    margin-top: 5%;
  }
}
</style>

